import BookmarkIcon from "../../../../animation/jobs/My jobs icon.svg";

import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ApplyIcon from "../../../../animation/jobs/Apply.svg";
import ContentCopyIcon from "../../../../animation/jobs/Copy link.svg";
import DeleteIcon from "../../../../animation/jobs/Delete.svg";
import MessageIcon from "../../../../animation/jobs/Message.svg";
import UnsaveIcon from "../../../../animation/jobs/Unsave.svg";
import Chat from "../../../../components/chat/Chat";
import { ChatProvider } from "../../../../components/chat/ChatContext";
import { ServiceApi } from "../../Service/ServiceApi";
import jobUtils from "../../utils/jobUtils";
import Pagination from "../Pagination/Pagination";
import "./Savejob.css";

function Savejob() {
  const [activeTab, setActiveTab] = useState("saved");
  const [menuOpen, setMenuOpen] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [savedJobs, setSavedJobs] = useState([]);
  const [appliedJobs, setAppliedJobs] = useState([]);
  const [activeMenu, setActiveMenu] = useState("jobs"); // NEW
  const [inProgressJobs, setInProgressJobs] = useState([]);
  const [archivedJobs, setArchivedJobs] = useState([]);
  const [pagination, setPagination] = useState({ count: 0, next: null, previous: null });
  const [loading, setLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [isChatListOpen, setisChatListOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [sidebarItems, setsidebarItems] = useState([
    { id: "jobs", label: "My Jobs", count: 0, icon: <img src={BookmarkIcon} /> },
    // { id: "learning", label: "My Learning", count: 0, icon: <img src={BookmarkIcon} /> },
    // { id: "posts", label: "Saved posts", count: 0, icon: <img src={BookmarkIcon} /> },
  ])

  const userData = JSON.parse(localStorage.getItem("userData"));
  const profileId = userData?.profile_id;
  const history = useHistory();
  const jobsPerPage = 10;
  const token = localStorage.getItem("token");
  
  const location = useLocation();




  const showToastMessage = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
      setToastMessage("");
    }, 3000);
  };

  const handleCloseToast = () => {
    setShowToast(false);
    setToastMessage("");
  };


  const fetchJobs = async (url = null, page = 1) => {
    setLoading(true);
    let job_status = activeTab;
    if (activeTab == 'progress') {
      job_status = 'applied';
    }
    try {
      const result = await ServiceApi.SavedGetApi(token, profileId, job_status, page, jobsPerPage);
      const jobs = result?.data || [];
      setPagination({
        count: result?.count || 0,
        next: result?.next,
        previous: result?.previous,
      });
      switch (activeTab) {
        case "saved":
          setSavedJobs(jobs);
          break;
        case "applied":
          setAppliedJobs(jobs);
          break;
        case "progress":
          setInProgressJobs(jobs);
          break;
        case "archived":
          setArchivedJobs(jobs);
          break;
        default:
          break;
      }
    } catch (err) {
      console.error("Error fetching jobs:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = async (job) => {
    history.push(`/jobview/${job.id}`);
  };

  const handlePageChange = (page, url) => {
    setCurrentPage(page);
    fetchJobs(url, page);
  };


  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);


  const sendMesage = (job) => {
    const link = `${window.location.origin}/jobview/${job?.id}`;
    setMessage(link)
    setisChatListOpen(true)
    setMenuOpen(null);
  }

  const deleteJob = async (userjob) => {
    try {
      await ServiceApi.DiscardApi(token,userjob.id)
      showToastMessage("Delete Job Successfully");
      setArchivedJobs(prev => prev.filter(j => j.id !== userjob.id));

    } catch (error) {
      console.error("Delete error:", error);
      showToastMessage("Faild to delete job");

    }
  }

 
 



  useEffect(() => {
    const totalAPi = async () => {
      try {
        const result = await ServiceApi.GetMyAllJobsApi(token, profileId);
        const updatedSidebar = sidebarItems.map((item, index) => {
          if (index === 0) {
            return { ...item, count: result.count };
          }
          return item;
        });
        setsidebarItems(updatedSidebar);
      } catch (err) {
        console.log("error fetching", err);
      }
    };
    totalAPi();
  }, []);

  useEffect(() => {
    if (token && profileId) {
      setCurrentPage(1);
      fetchJobs(null, 1);
    }
  }, [token, profileId, activeTab]);

  const getItems = () => {
    switch (activeTab) {
      case "saved":
        return savedJobs;
      case "progress":
        return inProgressJobs;
      case "applied":
        return appliedJobs;
      case "archived":
        return archivedJobs;
      default:
        return [];
    }
  };

  const DropdownButton = ({ icon, label, onClick }) => (
    <button className="dropdown-btn" onClick={onClick}>
      {icon}
      <span>{label}</span>
    </button>
  );


  const toggleChatList = () => {
    setisChatListOpen((prev) => !prev)
  }

  const handleCopy = (job) => {
    const link = `${window.location.origin}/jobview/${job?.id}`;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(link)
        .then(() => showToastMessage("🔗 Link copied to clipboard!"))
        .catch(() => showToastMessage("Failed to copy link."));
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = link;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        showToastMessage("🔗 Link copied to clipboard!");
      } catch {
        showToastMessage("Failed to copy link.");
      }
      document.body.removeChild(textArea);
    }

    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
    setMenuOpen(null);
  };

  const handleStatusChange = async (job, newStatus) => {
    try {
      await ServiceApi.UnsavedApi(token, newStatus, job.id);

      if (activeTab === "saved") {
        setSavedJobs((prev) => prev.filter((j) => j.id !== job.id));
      } else if (activeTab === "progress") {
        setInProgressJobs((prev) => prev.filter((j) => j.id !== job.id));
      } else if (activeTab === "applied") {
        setAppliedJobs((prev) => prev.filter((j) => j.id !== job.id));
      } else if (activeTab === "archived") {
        setArchivedJobs((prev) => prev.filter((j) => j.id !== job.id));
      }

      let message = "";
      if (newStatus === "progress") {
        message = "📥 Job moved to In Progress!";
        setInProgressJobs((prev) => [...prev, { ...job, status: newStatus }]);
      } else if (newStatus === "applied") {
        message = "✅ Job moved to Applied!";
        setAppliedJobs((prev) => [...prev, { ...job, status: newStatus }]);
      } else if (newStatus === "archived") {
        message = "🗑️ Job has been archived.";
        setArchivedJobs((prev) => [...prev, { ...job, status: newStatus }]);
      }

      showToastMessage(message);
      setMenuOpen(null);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    } catch (err) {
      console.error("Error updating job status:", err);
    }
  };

  return (

    <div className="page-container">
            {showToast && (
                  <div className="savejob-toastCard"><span>{toastMessage}</span>
<span className="closeIcon" onClick={handleCloseToast}>&times;</span>
</div>

  )}
      {/* Sidebar */}
      <div className="sidebar">
        <h3 className="sidebar-title">
          <img src={BookmarkIcon} className="sidebar-icon-upper" />
          <span className="sidebar-title-text">My items</span>
        </h3>
        <ul className="sidebar-list">
          {sidebarItems.map((item) => (
            <li
              key={item.id}
              className={`sidebar-item ${activeMenu === item.id ? "active" : ""}`}
              onClick={() => setActiveMenu(item.id)}
            >
              <div className="left">
                <span className={`dot ${activeMenu === item.id ? "active-dot" : ""}`}></span>
                <span className="sidebar-icon">{item.icon}</span>
                <span className="label">{item.label}</span>
              </div>
              <span className="count">{item.count}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Right Section */}
      <div className="jobs-container">
        {activeMenu === "jobs" && (
          <>
            <h3 className="jobs-title">My Jobs</h3>
            <div className="tabs">
              {["saved", "progress", "applied", "archived"].map((tab) => (
                <button
                  key={tab}
                  className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "saved" && "Saved"}
                  {tab === "progress" && "In Progress"}
                  {tab === "applied" && "Applied"}
                  {tab === "archived" && "Archived"}
                </button>
              ))}
            </div>


            {/* Job List + Pagination (only in jobs menu) */}
            <div className="job-list-container">
              {loading ? (
                <div className="loader">
                  <CircularProgress style={{ color: "#F33070" }} />
                </div>
              ) : getItems().length === 0 ? (
                <p className="no-saved">No {activeTab} jobs yet.</p>
              ) : (
                <div className="job-list">
                  {getItems().map((job) => (
                    <div key={job.id} className="job_card">
                      <div className="company-logo">
                        {job.job?.CompanyData?.company_logo ? (
                          <img
                            src={
                              jobUtils.decodeIfProxy(job.job.CompanyData.company_logo) ||
                              "/Image/fallback-company.png"
                            }
                            alt={`${job.job.CompanyData.company_name ?? "Company"} logo`}
                            className="company_logo"
                            onError={(e) => {
                              const img = e.currentTarget;
                              if (img.src && img.src.includes("/media/")) {
                                const decoded = jobUtils.decodeIfProxy(job.job.CompanyData.company_logo);
                                if (decoded && decoded !== img.src) {
                                  img.onerror = null;
                                  img.src = decoded;
                                  return;
                                }
                              }
                              img.onerror = null;
                              img.src = "/Image/fallback-company.png";
                            }}
                          />
                        ) : (
                          <div className="logo-placeholder">
                            {(job.job.CompanyData.company_name &&
                              job.job.CompanyData.company_name.charAt(0).toUpperCase()) ||
                              (job.job.title && job.job.title.charAt(0).toUpperCase()) ||
                              "J"}
                          </div>
                        )}
                      </div>

                      <div className="Job-info">
                        <h4 className="Job-title" onClick={() => handleClick(job.job)}>
                          <span className={job.job?.is_active ? "active" : "not-active"}>
                            {job.job?.title}
                          </span>
                        </h4>
                        <span className="Job-company">

                          {job.job?.CompanyData?.company_name}{" "}
                          {job.job?.remote &&
                            (job.job?.remote === "NA" ? "(On-site)" : "(Remote)")}
                        </span>
                        <br />
                        {job.job?.timestamp && (
                          <span className="Job-postedDate">
                            Posted {jobUtils.timeAgo(job.job?.timestamp)}
                          </span>
                        )}
                      </div>

                      <div className="job-menu">
                        <button
                          className="menu-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            setMenuOpen(menuOpen === job.id ? null : job.id);
                          }}
                        >
                          ...
                        </button>

                        {menuOpen === job.id && (
                          <div className="dropdown">
                            {activeTab === "saved" && (
                              <>
                                <DropdownButton
                                  icon={<img src={ApplyIcon}/>}
                                  label="Apply"
                                  onClick={() => handleStatusChange(job, "applied")}
                                />
                                <DropdownButton
                                  icon={<img src={MessageIcon} />}
                                  label="Send in a Message"
                                  onClick={() => sendMesage(job.job)}
                                />
                                <DropdownButton
                                  icon={<img src={ContentCopyIcon} />}
                                  label="Copy link"
                                  onClick={() => handleCopy(job.job)}
                                />
                                <DropdownButton
                                  icon={<img src={UnsaveIcon} />}
                                  label="Unsave"
                                  onClick={() => handleStatusChange(job, "archived")}
                                />
                              </>
                            )}

                            {activeTab === "progress" && (
                              <>
                                <DropdownButton
                                  icon={<img src={MessageIcon} />}
                                  label="Send in a Message"
                                  onClick={() => sendMesage(job.job)}
                                />
                                <DropdownButton
                                  icon={<img src={ContentCopyIcon} />}
                                  label="Copy link"
                                  onClick={() => handleCopy(job.job)}
                                />
                              </>
                            )}

                            {activeTab === "applied" && (
                              <>
                                <DropdownButton
                                  icon={<img src={MessageIcon} />}
                                  label="Send in a Message"
                                  onClick={() => sendMesage(job.job)}
                                />
                                <DropdownButton
                                  icon={<img src={ContentCopyIcon} />}
                                  label="Copy link"
                                  onClick={() => handleCopy(job.job)}
                                />
                              </>
                            )}

                            {activeTab === "archived" && (
                              <>
                                <DropdownButton
                                  icon={<img src={DeleteIcon} />}
                                  label="Discard"
                                  onClick={() => deleteJob(job)}

                                />

                                <DropdownButton
                                  icon={<img src={MessageIcon} />}
                                  label="Send in a Message"
                                  onClick={() => sendMesage(job.job)}
                                />
                                <DropdownButton
                                  icon={<img src={ContentCopyIcon} />}
                                  label="Copy link"
                                  onClick={() => handleCopy(job.job)}
                                />
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="save-pagination">
              <Pagination
                totalPages={Math.ceil(pagination.count / jobsPerPage)}
                currentPage={currentPage}
                onPageChange={(page) => handlePageChange(page)}
              />
            </div>
          </>
        )}

        {activeMenu === "learning" && (
          <div className="empty-section">
            <h3 className="jobs-title">My Learning</h3>
            <p className="jobs-container-learning">No learning items yet.</p>
          </div>
        )}

        {activeMenu === "posts" && (
          <div className="empty-section">
            <h3 className="jobs-title">Saved Posts</h3>
            <p className="jobs-container-learning">No posts saved yet.</p>
          </div>
        )}
      </div>
      <ChatProvider>
        <Chat
          message={message}
          toggleChatList={toggleChatList}
          isChatListOpen={isChatListOpen}
        />
      </ChatProvider>

    </div>
  );
}

export default Savejob;
